// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2pMEK","empty":"ModalGraph_empty__3wGuD"};